import React, {useEffect} from 'react'
import {
    Text,
    Image,
    IconButton,
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    useDisclosure,
    Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types';
import {Swiper, SwiperSlide} from 'swiper/react'
import {Navigation} from 'swiper/modules'
import {ChevronLeftIcon, ChevronRightIcon} from '../../icons'

/* Components */
import {HideOnMobile} from '@salesforce/retail-react-app/app/components/responsive'
import ReviewCard from './review-card'

const ExpandedImage = ({selectedReview, setSelectedReview, closeOtherModals}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    useEffect(() => {
        if (selectedReview?.review && Object.keys(selectedReview?.review).length > 0) {
            handleOnOpen();
        }
    }, [selectedReview?.review])

    const handleOnClose = () => {
        onClose();
        setSelectedReview({});
    }

    const handleOnOpen = () => {
        closeOtherModals.closeAllReviewsModal();
        onOpen();
    }

    return (
        <Drawer
            placement="right"
            isOpen={isOpen}
            onOpen={handleOnOpen}
            onClose={handleOnClose}
            size={{ base: 'full', md: 'sm' }}
            motionPreset="slideInBottom"
            scrollBehavior="inside"
            isFullHeight={true}
        >
            <DrawerOverlay />
            <DrawerContent marginTop={0}>
                <HideOnMobile>
                    <Flex alignItems={'center'}
                        px={{base: 6}}
                        mt={{base: 6}}
                        mb={{base: 4}}>
                        <IconButton
                            variant={'link'}
                            onClick={handleOnClose}
                            icon={<ChevronLeftIcon />}
                        />
                        <Text fontSize={{base: 'sm'}}
                            lineHeight={{base: '18px'}}
                            ml={{base: 2}}
                            cursor={'pointer'}
                            onClick={handleOnClose}>
                            <FormattedMessage
                                defaultMessage="Back"
                                id="pdp_reviews.modal.back"
                            />
                        </Text>
                    </Flex>
                </HideOnMobile>
                <DrawerCloseButton w={{base: 6}}
                    h={{base: 6}}
                    top={{base: '28px', lg: '26px'}}
                    right={{base: '16px', lg: '34px'}}
                    zIndex={'2'}
                />
                <DrawerBody
                    padding="0"
                    py={0}
                    px={{base: 0, lg: 6}}
                    sx={{
                        scrollbarGutter: {base: 'auto', lg: 'stable'}
                    }}>

                    <Swiper px={{base: 0, lg: 6}}
                        slidesPerView={1}
                        initialSlide={selectedReview?.index || 0}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: '.next-photo',
                            prevEl: '.prev-photo'
                        }}>
                        {selectedReview?.review?.Photos?.map((photo) => {
                            return (<SwiperSlide>
                                <Image cursor={'pointer'}
                                    w="100%"
                                    src={photo?.Sizes?.normal?.Url}
                                    alt="Review image"
                                    aria-label="Open review" />
                            </SwiperSlide>)
                        })}
                        {selectedReview?.review?.Photos?.length > 1 &&
                            <Flex position={'absolute'}
                                top={'50%'}
                                left={'0'}
                                transform={'translateY(-50%)'}
                                zIndex={'1'}
                                width={'100%'}
                                justifyContent={'space-between'}>
                                <IconButton
                                    width={'32px'}
                                    height={'32px'}
                                    className={'prev-photo'}
                                    variant={'link'}
                                    blur={'10'}
                                    backgroundColor={'white'}
                                    sx={{
                                        '&:disabled': {
                                            opacity: '50%',
                                            background: 'white !important'
                                        }
                                    }}
                                    icon={<ChevronLeftIcon />}
                                />
                                <IconButton
                                    width={'32px'}
                                    height={'32px'}
                                    className={'next-photo'}
                                    variant={'link'}
                                    blur={'10'}
                                    backgroundColor={'white'}
                                    sx={{
                                        '&:disabled': {
                                            opacity: '50%',
                                            background: 'white !important'
                                        }
                                    }}
                                    icon={<ChevronRightIcon />}
                                />
                            </Flex>
                        }
                    </Swiper>
                    <ReviewCard key={'rc-selected-' + selectedReview.Id} review={selectedReview?.review} configs={{
                        styles: {
                            container: {
                                border: 0,
                                px: {base: 4, lg: 0},
                                mb: {base: '80px'}
                            },
                            nickname: {
                                pb: {base: 2}
                            }
                        },
                        showMobileVersionToDesktop: true,
                        showDimensionStakedOnMobile: true,
                        showImages: false
                    }}/>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
};

ExpandedImage.propTypes = {
    selectedReview: PropTypes.object,
    setSelectedReview: PropTypes.func,
    closeOtherModals: PropTypes.object
};

export default ExpandedImage;
